import React from 'react'
import { Link } from 'react-router-dom'
import Paragraph from '../../scentregroup-ui/components/paragraph'

import { HOME } from '../paths'
import style from './index.module.scss'

const ErrorPage: React.FC<{ includeLinkToHome?: boolean }> = ({
  includeLinkToHome = true,
}) => (
  <div className={style.wrapper}>
    <h1 className={style.header}>Something went wrong</h1>
    <Paragraph>
      We are currently experiencing issues. Please contact us at
      support@westfield.com.au. Our team has been notified.
    </Paragraph>

    {includeLinkToHome ? (
      <Paragraph>
        <Link to={HOME} className={style.homeLink}>
          Take me home
        </Link>
      </Paragraph>
    ) : null}
  </div>
)

export default ErrorPage
